'use client'

import { useEffect } from 'react'
import type { CoreTemplatePageData } from '@query/common-query/Core-page-template/core-template.model'
import { NotFoundCard } from '@components/feature/common'
import { CoreTemplatePage } from '@components/page/CoreTemplatePage'

type NotFoundPageProps = {
  coreTemplatePageData?: CoreTemplatePageData
}

export function NotFoundPage({ coreTemplatePageData }: NotFoundPageProps) {
  // scroll to top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [])

  return (
    <>
      <NotFoundCard />
      {coreTemplatePageData && <CoreTemplatePage {...coreTemplatePageData} />}
    </>
  )
}
